/*
  src/redux/kpis/actions.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import {
  DASHBOARD_KPIS_REQUESTED,
  DASHBOARD_KPIS_LOADED,
  DASHBOARD_KPIS_FAILED_TO_LOAD,
  AGENCY_KPIS_REQUESTED,
  AGENCY_KPIS_LOADED,
  AGENCY_KPIS_FAILED_TO_LOAD,
  BRAND_KPIS_REQUESTED,
  BRAND_KPIS_LOADED,
  BRAND_KPIS_FAILED_TO_LOAD,
  CAMPAIGN_KPIS_REQUESTED,
  CAMPAIGN_KPIS_LOADED,
  CAMPAIGN_KPIS_FAILED_TO_LOAD,
  ALL_CAMPAIGN_KPIS_REQUESTED,
  ALL_CAMPAIGN_KPIS_LOADED,
  ALL_CAMPAIGN_KPIS_FAILED_TO_LOAD
} from './constants';

import callAPI from '../callAPI';
import { getActiveAgencyUser } from '../selectors';

import { 
  SALES_ACCOUNT_ID 
} from '../../../config';

import {
  FAKE_CAMPAIGN_RESULTS_1,
  FAKE_BRAND_RESULTS_1,
  FAKE_ENGAGEMENT_RESULTS_1,
  FAKE_CAMPAIGN_RESULTS_2,
  FAKE_BRAND_RESULTS_2,
  FAKE_ENGAGEMENT_RESULTS_2,
  FAKE_CAMPAIGN_RESULTS_3,
  FAKE_BRAND_RESULTS_3,
  FAKE_ENGAGEMENT_RESULTS_3
} from './demoData';



export function loadKPIsForAgency(agencyId){
  return callAPI({
    path:`/portal/v1/agency/${agencyId}/kpis`,
    begin:{
      type:DASHBOARD_KPIS_REQUESTED,
      payload:() => {}
    },
    success:{
      type:DASHBOARD_KPIS_LOADED,
      payload:(res,state) => {
        const activeUserAgencyId = getActiveAgencyUser(state).agencyId;

        if(activeUserAgencyId === SALES_ACCOUNT_ID){
          res.data.campaignKPIs.push(FAKE_CAMPAIGN_RESULTS_1);
          res.data.campaignKPIs.push(FAKE_CAMPAIGN_RESULTS_2);
          res.data.campaignKPIs.push(FAKE_CAMPAIGN_RESULTS_3);

          res.data.brandKPIs.push(FAKE_BRAND_RESULTS_1);
          res.data.brandKPIs.push(FAKE_BRAND_RESULTS_2);
          res.data.brandKPIs.push(FAKE_BRAND_RESULTS_3);
        }

        return res.data;
      },
      result:(res) => ({
        instances:res.data,
        hasNextPage:false,
        hasPreviousPage:false
      })
    },
    failure:{
      type:DASHBOARD_KPIS_FAILED_TO_LOAD
    }
  });
}

export function loadKPIsForAgencies(page=0,size=100){
  return callAPI({
    path:`/portal/v1/agency/stats?page=${page}&size=${size}`,
    begin:{
      type:AGENCY_KPIS_REQUESTED,
      payload:() => {}
    },
    success:{
      type:AGENCY_KPIS_LOADED,
      payload:(res) => res.data,
      result:(res) => ({
        instances:res.data,
        hasNextPage:res.page.totalPages > page + 1,
        hasPreviousPage:page > 0
      })
    },
    failure:{
      type:AGENCY_KPIS_FAILED_TO_LOAD,
      payload:() => {}
    }
  });
}

export function loadKPIsForAllCampaigns(excludePadlockCampaigns = false){
  return callAPI({
    path:`/portal/v1/kpi/campaigns?excludePadlockCampaigns=${excludePadlockCampaigns}`,
    begin:{
      type:ALL_CAMPAIGN_KPIS_REQUESTED,
      payload:() => {}
    },
    success:{
      type:ALL_CAMPAIGN_KPIS_LOADED,
      payload:(res,state) => res.data,
      result:(res) => ({
        instances:res.data,
        hasNextPage:false,
        hasPreviousPage:false
      })
    },
    failure:{
      type:ALL_CAMPAIGN_KPIS_FAILED_TO_LOAD,
      payload:() => {}
    }
  })
}

export function loadKPIsForBrands(){
  return callAPI({
    path:`/portal/v1/brand/stats`,
    begin:{
      type:BRAND_KPIS_REQUESTED,
      payload:() => {}
    },
    success:{
      type:BRAND_KPIS_LOADED,
      payload:(res) => res.data
    },
    failure:{
      type:BRAND_KPIS_FAILED_TO_LOAD,
      payload:() => {}
    }
  });
}

export function loadKPIsForAgencyBrands(agencyId){
  return callAPI({
    path:`/portal/v1/agency/${agencyId}/brand/stats`,
    begin:{
      type:BRAND_KPIS_REQUESTED,
      payload:() => {}
    },
    success:{
      type:BRAND_KPIS_LOADED,
      payload:(res) => res.data
    },
    failure:{
      type:BRAND_KPIS_FAILED_TO_LOAD,
      payload:() => {}
    }
  });
}

export function loadKPIsForCampaign(campaignId) {
  return callAPI({
    method: 'GET',
    path: `/portal/v1/campaign/${campaignId}/kpis`,
    begin: {
      type: CAMPAIGN_KPIS_REQUESTED,
      payload: () => {}
    },
    success: {
      type: CAMPAIGN_KPIS_LOADED,
      payload: (res,state) => {
        const activeUserAgencyId = getActiveAgencyUser(state).agencyId;

        if(activeUserAgencyId === SALES_ACCOUNT_ID && campaignId === FAKE_CAMPAIGN_RESULTS_1.campaignId){
          return FAKE_ENGAGEMENT_RESULTS_1;
        }

        if(activeUserAgencyId === SALES_ACCOUNT_ID && campaignId === FAKE_CAMPAIGN_RESULTS_2.campaignId){
          return FAKE_ENGAGEMENT_RESULTS_2;
        }

        if(activeUserAgencyId === SALES_ACCOUNT_ID && campaignId === FAKE_CAMPAIGN_RESULTS_3.campaignId){
          return FAKE_ENGAGEMENT_RESULTS_3;
        }

        return res.data
      },
      result:(res) => ({
        instances:res.data,
        hasNextPage:false,
        hasPreviousPage:false
      })
    },
    failure: {
      type: CAMPAIGN_KPIS_FAILED_TO_LOAD
    }
  });
}



// WEBPACK FOOTER //
// ./src/shared/redux/kpis/actions.js